import { makeEnvironmentProviders } from '@angular/core';
import { provideRootTransloco } from './transloco-root.provider';
import { providePreloadLang } from './preload-lang.initializer';
import { provideStaticScope } from './transloco.loader';

export function provideTranslate() {
  return makeEnvironmentProviders([provideRootTransloco(), providePreloadLang(), provideStaticScope('')]);
}
